import { render, staticRenderFns } from "./CardCompetencies.vue?vue&type=template&id=6e4350ff&scoped=true"
import script from "./CardCompetencies.vue?vue&type=script&lang=js"
export * from "./CardCompetencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4350ff",
  null
  
)

export default component.exports